export const DEFAULT_VIEW_PATH = "/";